import i18n from 'i18next'

import { useTranslation, Trans } from "react-i18next";

import Fade from 'react-reveal/Fade'

import gr from '../../img/MansoryMesh/gr.webp';
import build from '../../img/MansoryMesh/build.webp'

import { Link } from "react-router-dom"

function ContactUs () {

    const { t } = useTranslation();
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] md:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto relative">
                <div className='md:h-[322px] w-full bg-[#404040] relative flex flex-col md:flex-row'>
                    <div className='flex flex-col items-center md:items-start justify-between mx-[20px] md:mx-[40px] xl:mx-[70px] mt-[40px] md:mt-0 md:py-[55px]'>
                        <p className='open-sans text-[28px] xl:text-[45px] text-[#F26522] leading-[1.4]'>{t('compositerein.add.25')}</p>
                        <p className='spanfont open-sans text-[#F6F6F6] text-[14px] xl:text-[20px] md:max-w-[250px] xl:max-w-[455px] text-center md:text-start mt-[15px] md:mt-0'><Trans>{t('compositerein.add.26')}</Trans></p>
                        <Link to="/form" className='mt-[35px] md:mt-0'>
                            <div className="contactus mr-auto hover:scale-[1.1] transition-all">
                                <p className="montserrat font-[600] text-[14px] xl:text-[16px]">{t('home.5')}</p>
                            </div>
                        </Link>
                    </div>
                    <Fade right delay={500}><img src={gr} alt="" className='absolute md:relative right-1/2 md:right-0 w-[150px] xl:w-auto bottom-0'/></Fade>
                    <Fade><img src={build} className={`md:absolute bottom-[-1px] mt-[20px] xl:mt-[55px] md:mt-0 sm:px-[100px] object-cover w-[250px] sm:w-auto ${i18n.language === 'ar' ? 'mr-auto left-0' : 'ml-auto right-0'}`} alt="" /></Fade>
                </div>
            </div>
        </div>
    );
}

export default ContactUs;